export function openNotification (url) {
  const patterns = ['localhost', 'ggsdev', 'greengeeks']
  let windowTarget = '_blank'

  for (let i = 0; i <= patterns.length; i++) {
    if (url.indexOf(patterns[i]) !== -1) {
      windowTarget = '_self'
    }
  }

  window.open(url, windowTarget)
}
